import React, { useState } from "react";
import { Link } from "react-router-dom";

type ShowMoreTextProps = {
  text: string;
  limit?: number;
};

const ShowMoreText: React.FC<ShowMoreTextProps> = ({ text, limit = 200 }) => {
  const [showMore, setShowMore] = useState(false);

  const isLong = text.length > limit;
  const displayedText = showMore || !isLong ? text : text.slice(0, limit) + "...";

  return (
    <div className="read-more">
      <p>{displayedText}</p>
      {isLong && (
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            setShowMore(!showMore);
          }}
          className="fs-14 fw-medium more-link text-decoration-underline"
        >
          {showMore ? "Show Less" : "Show More"}
        </Link>
      )}
    </div>
  );
};

export default ShowMoreText;
